// 自营挂账
import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 数据
/* export function autotrophygz(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/brand/findBrandPage',
    method: 'get',
    params
  })
}


// 联盟挂账
// 数据
export function coalitionifon(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/brand/findBrandPage',
    method: 'get',
    params
  })
} */

//自营挂账数据
export function syncCreditMsgzy(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/buyCredit/syncCreditMsg',
    method: 'get',
    params
  })
}
// 联盟挂账
// 数据
export function syncCreditMsglm(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/buyCredit/syncCreditMsg',
    method: 'get',
    params
  })
}